export default __webpack_public_path__ + "static/media/Bar.63627329.svg";